import React, { useRef, useState } from "react";
import { IconButtonProps } from "./IconButton.types";
import { ButtonContainer, Tooltip } from "./IconButton.styles";
import { Icon } from "components/Icon";
import TooltipPortal from "../../TooltipPortal/TooltipPortal";

const IconButton: React.FC<IconButtonProps> = ({
  icon,
  onClick,
  href,
  altText,
  tooltip,
  tone = "default",
  className,
}) => {
  const buttonRef = useRef<HTMLElement>(null);
  const [isTooltipVisible, setIsTooltipVisible] = useState(false);
  const handleShowTooltip = () => setIsTooltipVisible(true);
  const handleHideTooltip = () => setIsTooltipVisible(false);

  if (href) {
    return (
      <>
        <ButtonContainer
          as="a"
          href={href}
          aria-label={altText}
          $tone={tone}
          className={className}
          ref={buttonRef as React.RefObject<HTMLAnchorElement>}
          onMouseEnter={handleShowTooltip}
          onMouseLeave={handleHideTooltip}
          onFocus={handleShowTooltip}
          onBlur={handleHideTooltip}
        >
          <Icon glyph={icon} size="lg" />
        </ButtonContainer>
        {tooltip && isTooltipVisible && (
          <TooltipPortal targetRef={buttonRef}>
            <Tooltip role="tooltip" $visible={isTooltipVisible}>{tooltip}</Tooltip>
          </TooltipPortal>
        )}
      </>
    );
  }

  return (
    <>
      <ButtonContainer
        as="button"
        onClick={onClick}
        type="button"
        aria-label={altText}
        $tone={tone}
        className={className}
        ref={buttonRef as React.RefObject<HTMLButtonElement>}
        onMouseEnter={handleShowTooltip}
        onMouseLeave={handleHideTooltip}
        onFocus={handleShowTooltip}
        onBlur={handleHideTooltip}
      >
        <Icon glyph={icon} size="lg" />
      </ButtonContainer>
      {tooltip && isTooltipVisible && (
        <TooltipPortal targetRef={buttonRef}>
          <Tooltip role="tooltip" $visible={isTooltipVisible}>{tooltip}</Tooltip>
        </TooltipPortal>
      )}
    </>
  );
};

export default IconButton;
